import Filter from "./features/Filter";
import List from "./features/List";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {OrdersListElementType, OrdersSearchParamType} from "./interface";
import {ordersListMapInit, ordersSearchParamInit} from "./state";
import {useReadShipmentList} from "./hooks/useReadShipmentList";
import moment from "moment/moment";

export default function OrdersList() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<OrdersSearchParamType>((() => ({
        ...ordersSearchParamInit,
        fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment().add(1, 'month').startOf('month').format("YYYY-MM-DD")
    }))())
    const [checkedElements, setCheckedElements] = useState<OrdersListElementType[]>([])

    const {data: orders} = useReadShipmentList({param: searchParam});

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return (
        <>
            <Filter searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    setCheckedElements={setCheckedElements}/>

            <List orders={orders ?? ordersListMapInit}
                  searchParam={searchParam}
                  checkedElements={checkedElements}
                  setCheckedElements={setCheckedElements}/>
        </>
    );
}